module.exports = __webpack_public_path__ + "img/relacao_gestor.241c3e79.svg";